import axios from "axios";

const mainnetUrl = process.env.REACT_APP_DAFFI_MAINNET_URL;
const testnetUrl = process.env.REACT_APP_DAFFI_TESTNET_URL;

const mainnetHeaders = {
	"api-access-key": process.env.REACT_APP_DAFFI_MAINNET_API_KEY,
};
const testnetHeaders = {
	"api-access-key": process.env.REACT_APP_DAFFI_TESTNET_API_KEY,
};

//	Assets Apis
export const searchAssets = async (searchQueryString, algoChain) =>
	await axios.get(`${algoChain === "testnet" ? testnetUrl : mainnetUrl}/assets`, {
		headers: algoChain === "testnet" ? testnetHeaders : mainnetHeaders,
		params: { searchQueryString: searchQueryString },
	});

export const getAllAssets = async (algoChain) =>
	await axios.get(`${algoChain === "testnet" ? testnetUrl : mainnetUrl}/assets/getAllAssets`, {
		headers: algoChain === "testnet" ? testnetHeaders : mainnetHeaders,
	});

export const getWellKnownAssets = async (algoChain) =>
	await axios.get(`${algoChain === "testnet" ? testnetUrl : mainnetUrl}/assets`, {
		headers: algoChain === "testnet" ? testnetHeaders : mainnetHeaders,
		params: { wellKnown: true },
	});

export const getAssetInfoByID = async (params, algoChain) =>
	await axios.get(`${algoChain === "testnet" ? testnetUrl : mainnetUrl}/assets`, {
		headers: algoChain === "testnet" ? testnetHeaders : mainnetHeaders,
		params: params,
	});

// Alammex Apis
export const getAssetPricesByAlammex = async () => await axios.get("https://app.alammex.com/api/assetPrices?");

export const getFixedInputSwapQuote = async (formData, algoChain) =>
	await axios.post(`https://${algoChain === "mainnet" ? "app" : "testnet"}.alammex.com/api/fetchQuote`, formData);

export const getFixedOutputSwapQuote = async (formData, algoChain) =>
	await axios.post(`https://${algoChain === "mainnet" ? "app" : "testnet"}.alammex.com/api/fetchQuote`, formData);

export const executeSwapTxns = async (formData, algoChain) =>
	await axios.post(`https://${algoChain === "mainnet" ? "app" : "testnet"}.alammex.com/api/executeSwapTxns`, formData);

export const getAssetTransactionsByID = async (assetID, accountID, pageNum, limit, algoChain) =>
	await axios.get(`${algoChain === "testnet" ? testnetUrl : mainnetUrl}/assets/transactions`, {
		headers: algoChain === "testnet" ? testnetHeaders : mainnetHeaders,
		params: { assetID: assetID, accountID: accountID, pageNum: pageNum, limit: limit },
	});

//	Accounts Apis

export const getNFDByAccountID = async (accountID) =>
	await axios.get(`https://api.nf.domains/nfd/address`, {
		params: { address: accountID },
	});

export const searchAccountIDsByNFD = async (nfd) =>
	await axios.get(`https://api.nf.domains/nfd`, {
		params: { prefix: nfd },
	});

export const getAccountIDByNFD = async (nfd) => await axios.get(`https://api.nf.domains/nfd/` + nfd);

export const getAccountInfoById = async (accountID, baseCurrency, algoChain) =>
	await axios.get(`${algoChain === "testnet" ? testnetUrl : mainnetUrl}/accounts`, {
		headers: algoChain === "testnet" ? testnetHeaders : mainnetHeaders,
		params: { accountID: accountID, baseCurrency: baseCurrency },
	});

export const getAccountAmountById = async (accountID, baseCurrency, algoChain) =>
	await axios.get(`${algoChain === "testnet" ? testnetUrl : mainnetUrl}/accounts`, {
		headers: algoChain === "testnet" ? testnetHeaders : mainnetHeaders,
		params: {
			accountID: accountID,
			baseCurrency: baseCurrency,
			exclude: ["apps-local-state", "apps-total-schema", "assets"],
		},
	});

export const getTimestampByAccountID = async (accountID, algoChain) =>
	await axios.get(`${algoChain === "testnet" ? testnetUrl : mainnetUrl}/accounts/timestamp`, {
		headers: algoChain === "testnet" ? testnetHeaders : mainnetHeaders,
		params: { accountID: accountID },
	});

export const getAccountTransactionsByID = async (accountID, pageNum, limit, algoChain) =>
	await axios.get(`${algoChain === "testnet" ? testnetUrl : mainnetUrl}/accounts/transactions`, {
		headers: algoChain === "testnet" ? testnetHeaders : mainnetHeaders,
		params: { accountID: accountID, pageNum: pageNum, limit: limit },
	});

export const getAssetInfoFromAccount = async (formData, algoChain) =>
	await axios.get(`${algoChain === "testnet" ? testnetUrl : mainnetUrl}/accounts/asset`, {
		headers: algoChain === "testnet" ? testnetHeaders : mainnetHeaders,
		params: formData,
	});

// export const getHelpMeOutQuote = async (algoChain) =>
// 	await axios.get(`${algoChain === "testnet" ? testnetUrl : mainnetUrl}/accounts/getHelpMeOutQuote`, {
// 		headers: algoChain === "testnet" ? testnetHeaders : mainnetHeaders,
// 	});

// export const fundAlgoInNewAccount = async (formData, algoChain) =>
// 	await axios.post(
// 		`${algoChain === "testnet" ? testnetUrl : mainnetUrl}/transactions/fundAlgoInNewAccount`,
// 		{ data: formData },
// 		{
// 			headers: algoChain === "testnet" ? testnetHeaders : mainnetHeaders,
// 		}
// 	);

// export const fundAssetInNewAccount = async (formData, algoChain) =>
// 	await axios.post(
// 		`${algoChain === "testnet" ? testnetUrl : mainnetUrl}/transactions/fundAssetInNewAccount`,
// 		{ data: formData },
// 		{
// 			headers: algoChain === "testnet" ? testnetHeaders : mainnetHeaders,
// 		}
// 	);

// Users API
// export const registerUser = async (formData) =>
// 	await axios.post(`${mainnetUrl}/users/registerUser`, formData, {
// 		headers: mainnetHeaders,
// 	});

// export const sendEmailVerificationOTP = async (formData) =>
// 	await axios.post(`${mainnetUrl}/users/sendEmailVerificationOTP`, formData, {
// 		headers: mainnetHeaders,
// 	});

// export const verifyEmailByOTP = async (formData) =>
// 	await axios.post(`${mainnetUrl}/users/verifyEmailByOTP`, formData, {
// 		headers: mainnetHeaders,
// 	});

// export const loginUser = async (formData) =>
// 	await axios.post(`${mainnetUrl}/users/loginUser`, formData, {
// 		headers: mainnetHeaders,
// 	});

// export const verifyUserLogin = async (token) =>
// 	await axios.post(
// 		`${mainnetUrl}/users/verifyUserLogin`,
// 		{ token: token },
// 		{
// 			headers: mainnetHeaders,
// 		}
// 	);

// export const checkUsernameAvailability = async (username) =>
// 	await axios.get(`${mainnetUrl}/users/checkUsernameAvailability`, {
// 		headers: mainnetHeaders,
// 		params: { username: username },
// 	});

// export const checkEmailAvailability = async (email) =>
// 	await axios.get(`${mainnetUrl}/users/checkEmailAvailability`, {
// 		headers: mainnetHeaders,
// 		params: { email: email },
// 	});

// export const getUserByUsername = async (token) =>
// 	await axios.post(
// 		`${mainnetUrl}/users/getUserByUsername`,
// 		{ token: token },
// 		{
// 			headers: mainnetHeaders,
// 		}
// 	);

// export const updateProfileInfoByID = async (formData, token) =>
// 	await axios.post(
// 		`${mainnetUrl}/users/updateProfileInfoByID`,
// 		{ data: formData, token: token },
// 		{
// 			headers: mainnetHeaders,
// 		}
// 	);

// export const getUserPreferencesByUsername = async (token) =>
// 	await axios.post(
// 		`${mainnetUrl}/users/getUserPreferencesByUsername`,
// 		{ token: token },
// 		{
// 			headers: mainnetHeaders,
// 		}
// 	);

// export const updateUserPreferencesByID = async (formData, token) =>
// 	await axios.post(
// 		`${mainnetUrl}/users/updateUserPreferencesByID`,
// 		{ data: formData, token: token },
// 		{
// 			headers: mainnetHeaders,
// 		}
// 	);

// export const getAllAccountsByUser = async (formData, token) =>
// 	await axios.post(
// 		`${mainnetUrl}/users/getAllAccountsByUser`,
// 		{ sort: formData, token: token },
// 		{
// 			headers: mainnetHeaders,
// 		}
// 	);

// export const getAllContactsByUser = async (token) =>
// 	await axios.post(
// 		`${mainnetUrl}/users/getAllContactsByUser`,
// 		{ token: token },
// 		{
// 			headers: mainnetHeaders,
// 		}
// 	);

// export const addNewAccountInUserProfile = async (formData, token) =>
// 	await axios.post(
// 		`${mainnetUrl}/users/addAccount`,
// 		{ data: formData, token: token },
// 		{
// 			headers: mainnetHeaders,
// 		}
// 	);

// export const updateAccountInfoByID = async (formData, token) =>
// 	await axios.post(
// 		`${mainnetUrl}/users/updateAccountInfoByID`,
// 		{ data: formData, token: token },
// 		{
// 			headers: mainnetHeaders,
// 		}
// 	);

// export const updateAccountListSortByUserID = async (formData, token) =>
// 	await axios.post(
// 		`${mainnetUrl}/users/updateAccountListSortByUserID`,
// 		{ data: formData, token: token },
// 		{
// 			headers: mainnetHeaders,
// 		}
// 	);

// export const deleteAccountFromUserProfile = async (formData, token) =>
// 	await axios.post(
// 		`${mainnetUrl}/users/deleteAccountFromUserProfile`,
// 		{ data: formData, token: token },
// 		{
// 			headers: mainnetHeaders,
// 		}
// 	);

// export const addNewContact = async (formData, token) =>
// 	await axios.post(
// 		`${mainnetUrl}/users/addContact`,
// 		{ data: formData, token: token },
// 		{
// 			headers: mainnetHeaders,
// 		}
// 	);

// export const updateContactInfoByID = async (formData, token) =>
// 	await axios.post(
// 		`${mainnetUrl}/users/updateContactInfoByID`,
// 		{ data: formData, token: token },
// 		{
// 			headers: mainnetHeaders,
// 		}
// 	);

// export const deleteContactById = async (formData, token) =>
// 	await axios.post(
// 		`${mainnetUrl}/users/deleteContactByID`,
// 		{ data: formData, token: token },
// 		{
// 			headers: mainnetHeaders,
// 		}
// 	);

///////////////////////
// Notifications apis
///////////////////////

export const getNotificationDeviceByID = async (deviceID) =>
	await axios.get(`${mainnetUrl}/notificationDevices`, {
		headers: mainnetHeaders,
		params: { deviceID: deviceID },
	});

export const registerDeviceForNotification = async (formData) =>
	await axios.post(`${mainnetUrl}/notificationDevices`, formData, {
		headers: mainnetHeaders,
	});

// export const addAccountInNotificationDevice = async (formData) =>
// 	await axios.patch(`${mainnetUrl}/notificationDevices/accounts`, formData, {
// 		headers: mainnetHeaders,
// 	});

export const updateAllAccountsInNotificationDevice = async (formData) =>
	await axios.post(`${mainnetUrl}/notificationDevices`, formData, {
		headers: mainnetHeaders,
	});
